import { map } from 'lodash'
import { success, error } from '@/utils/alert'
import moment from 'moment'

export default {
  formatDate (date) {
    return moment(date).format('DD/MM')
  },
  doDelayedAll () {
    const ids = map(this.schedules, schedule => {
      return schedule.id
    })

    this.$resource.put(ids.toString() + '/delayed')
      .then(({data}) => {
        success('Horário(s) confirmado como atrasado com sucesso.')
        this.$emit('close', data)
      })
      .catch(() => {
        error('Ocorreu um erro ao confirmar este horário.')
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/schedulings/components/delayed/resources/methods.js